// extracted by mini-css-extract-plugin
export default {"full-width-image":"FullWidthImage_full-width-image__yiLMY","full-image":"FullWidthImage_full-image__IhtaP"};